module.exports = __webpack_public_path__ + "static/media/logoosgeo_medium@2x.71352f6a.jpg";